import { render, staticRenderFns } from "./Reservesure.vue?vue&type=template&id=68c61ae0&scoped=true&"
import script from "./Reservesure.vue?vue&type=script&lang=js&"
export * from "./Reservesure.vue?vue&type=script&lang=js&"
import style0 from "./Reservesure.vue?vue&type=style&index=0&id=68c61ae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c61ae0",
  null
  
)

export default component.exports